import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { AutoAwesome as AiIcon } from '@mui/icons-material';
import { useAppDispatch } from '@/store';
import { setAiChatOpen } from '@/store/slices/uiSlice';
import { useKiFunktion } from '@/hooks/useKiFunktion';
import { CHAT_ORANGE, CHAT_ORANGE_AKTIV } from './chat-farben';

/**
 * Der Co-Auditor in der Kopfleiste — beschriftet, nicht nur als Symbol.
 *
 * Die übrigen Knöpfe oben sind Symbole, weil jeder weiß, was eine Lupe tut.
 * Bei einem Assistenten weiß es niemand: Ein Wort daneben ist der Unterschied
 * zwischen einem Angebot und einer Verzierung.
 */
export const AiChatEntry: React.FC = () => {
  const dispatch = useAppDispatch();
  const ki = useKiFunktion('record_question');

  if (!ki.verfuegbar) return null;

  return (
    <Tooltip title="Fragen an den eigenen Bestand — der Assistent schreibt nichts">
      <Button
        variant="contained"
        size="small"
        disableElevation
        startIcon={<AiIcon />}
        onClick={() => dispatch(setAiChatOpen(true))}
        sx={{
          mr: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 5,
          px: 1.75,
          // Auf dem dunklen Kopfbalken trennt ein heller Grund besser als ein
          // dunkler — und trägt dunklen Text mit 7,06 statt weißen mit 3,09.
          bgcolor: CHAT_ORANGE,
          color: 'primary.dark',
          '&:hover': { bgcolor: CHAT_ORANGE_AKTIV, color: '#fff' },
        }}
      >
        Co-Auditor
      </Button>
    </Tooltip>
  );
};
